import { render, staticRenderFns } from "./Smtp.vue?vue&type=template&id=1a200e8f"
import script from "./Smtp.vue?vue&type=script&lang=js"
export * from "./Smtp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports